import React from "react";

// icons for page
import Ionicon from "react-ionicons";
export const NavigationArrow = e => (
  <div
    className={`pageNav perfectCenter ${
      e === "next" ? "pageNavRight" : "pageNavLeft"
    }`}
  >
    <Ionicon
      icon={e === "next" ? "ios-arrow-forward" : "ios-arrow-back"}
      color="#ffffff"
      fontSize="30px"
      className="pageNavIcon"
    />
  </div>
);
export const edit = e => (
  <Ionicon
    icon="ios-create-outline"
    fontSize={`${e}px`}
    color="#bdc3c7"
    className="editIcon"
  />
);
